import {
  useCurrentWorkspace,
  useFindAssetIdForWorkspace,
} from '@gripp/shared-logic';
import {
  LoadingIndicator,
  SlideAction,
  SlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import ActivityEditLabels from '../../activity/components/activity-edit-label';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { AssetCard } from '../../assets/components/assetCard';
import { AssetFilters } from '../../assets/components/assetFilters';
import { NewIssueBody } from '../../issues';
import { HeaderResetButton } from '../../shared/components/headerResetButton';

export const WorkspaceNewIssue = () => {
  const { workspaceId = '' } = useParams();
  const navigate = useNavigate();
  const { assetId, isLoading } = useFindAssetIdForWorkspace(workspaceId);
  const [selectedLabels, setSelectedLabels] = useState<
    Array<{ id: string; name: string }>
  >([]);
  const currentWorkspace = useCurrentWorkspace();
  const resetLabelsRef = useRef<(() => void) | undefined>(undefined);

  const basePath = `/workspaces/${workspaceId}`;
  const routeContext = {
    basePath,
    listPath: '/workspaces',
    isWorkspaceMode: true,
  };

  const leftColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <AssetRouteProvider value={routeContext}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ) : null,
    headerComponent:
      !isLoading && assetId ? (
        <AssetRouteProvider value={routeContext}>
          <AssetFilters assetId={assetId} />
        </AssetRouteProvider>
      ) : null,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(basePath);
    },
  };

  const rightColumn = {
    title: 'asset.header.buttons.addSomething',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <NewIssueBody
        assetId={assetId}
        workspaceId={currentWorkspace?.id}
        isOpened={true}
        modalType="sheet"
        onComplete={() => navigate(basePath)}
        onCancel={() => navigate(basePath)}
        onIssueCreated={(issueId) =>
          navigate(`${basePath}/activity/${issueId}`)
        }
        selectedLabels={selectedLabels}
        onLabelsChange={setSelectedLabels}
      />
    ) : null,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(basePath);
    },
    disableScroll: true,
  };

  const thirdColumn = {
    title: 'asset.groups',
    mainComponent: (
      <ActivityEditLabels
        selectedLabels={selectedLabels ?? []}
        onLabelsChange={setSelectedLabels}
        resetRef={resetLabelsRef}
      />
    ),
    headerComponent: (
      <View style={styles.headerResetButton}>
        <HeaderResetButton onReset={() => resetLabelsRef.current?.()} />
      </View>
    ),
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  headerResetButton: {
    marginRight: 8,
  },
});
